import { useContext } from "react";
import { AppContext } from "@vahak/core/dist/app-context";
import { useCsDashboard } from "@vahak/core/dist/hooks/useCsDashboard";
import { copyToClipboard } from "@vahak/core/dist/methods/copyToClipboard";

const useDirectCall = () => {
    const { fromFlutterApp } = useContext(AppContext);
    const { isTsoV2 } = useCsDashboard();

    const directCall = (phoneNumber?: string) => {
        if (!phoneNumber) {
            console.warn("Phone number is empty.");
            return;
        }

        // Sanitize input (basic)
        const cleaned = phoneNumber.replace(/[^+\d]/g, "");

        // Flutter WebView has no usable dialer — copy instead of tel:
        if (isTsoV2 && fromFlutterApp) {
            copyToClipboard(cleaned, "Phone number copied!");
            return;
        }

        // Open the tel link
        window.location.href = `tel:${cleaned}`;
    };

    return {
        directCall
    };
};

export default useDirectCall;
